module.exports = __webpack_public_path__ + "static/forest-2-a0438a969e50c0f996cd67b7dd1c8a26.jpg";